<div class="cb-user-avatar">
    @switch(shownType()){
    @case ('text'){
    <cb-avatar type="initials" [size]="size()" [label]="shownLabel()" [subtitle]="subtitle()"
        [onlyAvatar]="onlyAvatar()" [randomColor]="true" [customInitials]="shownInitials()"></cb-avatar>
    }
    @case ('random'){
    <cb-avatar type="icon" [profileIcon]="'cb-base-avatar-'+randomIndex" [size]="size()" [label]="shownLabel()"
        [subtitle]="subtitle()" [onlyAvatar]="onlyAvatar()" [randomColor]="true"></cb-avatar>
    }
    @case ('image'){
    <cb-avatar [type]="(shownUrl() && shownUrl()!.length > 0)? 'image' : 'placeholder'" [size]="size()"
        [label]="shownLabel()" [subtitle]="subtitle()" [onlyAvatar]="onlyAvatar()" [url]="shownUrl() + scaleParams()"
        [randomColor]="true"></cb-avatar>
    }
    }
</div>